module.exports = __webpack_public_path__ + "img/mainni.df05463a.svg";